// extracted by mini-css-extract-plugin
export default {"container":"MentionsLegalesPage_container__B5XQ4","link":"MentionsLegalesPage_link__iggcL"};